import React from 'react';
import { createTheme, ThemeProvider, CssBaseline } from '@mui/material';
import App from './App';

const ThemedApp = () => {
    // Cria o tema com o modo 'light' fixo
    const theme = createTheme({
        palette: {
            mode: 'light', // Mantém o modo claro
        },
    });

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <App />
        </ThemeProvider>
    );
}

export default ThemedApp;
